import {
  SHIMMER_INTERVAL_MS,
  computeGlimmerIndex,
  computeShimmerSegments,
  timestamp,
} from '@/Claude/bridge/bridgeStatusUtil';
import { stringWidth } from '@/Claude/ink/stringWidth';
import { formatDuration, formatNumber } from '@/Claude/utils/format';
import { truncatePathMiddle, truncateToWidth } from '@/Claude/utils/truncate';

export const CLAUDE_BROWSER_AUDIT = {
  browserSafe: [
    'src/Claude/ink/stringWidth.ts',
    'src/Claude/utils/intl.ts',
    'src/Claude/utils/format.ts',
    'src/Claude/utils/truncate.ts',
    'src/Claude/bridge/bridgeStatusUtil.ts',
  ],
  adapterRequired: [
    'src/Claude/screens/REPL.tsx',
    'src/Claude/components/PromptInput/*',
    'src/Claude/components/messages/*',
    'src/Claude/hooks/useGlobalKeybindings.tsx',
    'src/Claude/tools/*',
  ],
  cliOnly: [
    'src/Claude/main.tsx',
    'src/Claude/replLauncher.tsx',
    'src/Claude/bridge/sessionRunner.ts',
    'src/Claude/ink/root.ts',
    'src/Claude/ink/ink.tsx',
  ],
} as const;

export { SHIMMER_INTERVAL_MS, stringWidth, formatDuration, formatNumber, truncatePathMiddle, truncateToWidth, timestamp };

export function buildThinkingFrame(label: string, tick: number) {
  const width = Math.max(1, stringWidth(label));
  const glimmerIndex = computeGlimmerIndex(tick, width);
  return computeShimmerSegments(label, glimmerIndex);
}

export function buildSessionMeta(params: {
  startedAt: number;
  messageCount: number;
  currentPath: string;
  modelName: string;
  trustEnabled: boolean;
}) {
  const elapsedMs = Math.max(0, Date.now() - params.startedAt);

  return {
    timestamp: timestamp(),
    elapsed: formatDuration(elapsedMs, { hideTrailingZeros: true }),
    messageCount: formatNumber(params.messageCount),
    path: truncatePathMiddle(params.currentPath, 36),
    model: truncateToWidth(params.modelName || 'none', 24),
    trustLabel: params.trustEnabled ? 'on' : 'off',
  };
}
